import { Form, Upload } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import { useUploadFileRule } from "../../../../lib/hooks/useUploadFileRule";
import { useUploadFile } from "../../../../lib/hooks/useUploadFile";
import { useMemo } from "react";
import { Rule } from "antd/es/form";

const { Dragger } = Upload;

type FormUploadProps = {
  setIsUploading: React.Dispatch<React.SetStateAction<boolean>>;
};

export const FormUpload = ({ setIsUploading }: FormUploadProps) => {
  const { rule } = useUploadFileRule();

  const { upload } = useUploadFile(6, setIsUploading);

  const fullRules: Rule[] = useMemo(
    () => [{ required: true }, ...rule],
    [rule],
  );

  return (
    <Form.Item
      name="file"
      className="mt-6 mb-4 w-100"
      valuePropName="fileList"
      getValueFromEvent={(e) => e.fileList}
      rules={fullRules}
    >
      <Dragger
        multiple={false}
        listType="picture"
        customRequest={upload}
        previewFile={async () => ""}
        maxCount={1}
      >
        <UploadOutlined className="text-md title" />
        <p className="mb-0 mt-2 text-md title">
          Click or drag PDF file to this area to upload
        </p>
      </Dragger>
    </Form.Item>
  );
};
